// @flow
import * as React from 'react';
import withStyles, {
  type StyleRulesCallback,
  type WithStyles,
} from '@material-ui/core/styles/withStyles';
import type { Theme } from '@material-ui/core/styles';
import Button, { type ButtonProps } from '@material-ui/core/Button';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import Link from '~plugins/i18n/components/Link';

export type ClassKey = 'root' | 'text';

export type Props = {
  ...$Exact<ButtonProps<'button', {}>>,
  ...$Exact<WithStyles<ClassKey>>,
  label: string,
};

export type Styles = StyleRulesCallback<Theme, Props, ClassKey>;

export const styles: Styles = theme => ({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  text: {
    color: theme.palette.primary.main,
  },
});

const DrawerItem = ({ label, classes, ...props }: Props): React.Node => {
  return (
    <Button
      component={Link}
      disableRipple
      classes={{ root: classes.root }}
      {...props}
    >
      <ListItem aria-label={label}>
        <ListItemText
          primary={label}
          primaryTypographyProps={{ variant: 'h4', className: classes.text }}
        />
      </ListItem>
    </Button>
  );
};

export default withStyles<*, *, Props>(styles)(DrawerItem);
